import React from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { Box } from "@mui/material"
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import usLocale from "date-fns/locale/en-US"
import { ThemeProvider, StyledEngineProvider, useTheme } from "@mui/material/styles"
import "@fontsource/roboto"
import CssBaseline from "@mui/material/CssBaseline"
import "./css/App.css"
import PrivateRoute from "./components/PrivateRoute"
import Login from "./pages/Login"
import PasswordForgot from "./pages/PasswordForgot"
import PublicRoute from "./components/PublicRoute"
import Products from './pages/Products'
import Menu from "./pages/Menu"
import Cart from "./pages/Cart"
import Checkout from "./pages/Checkout"
import NotFound from "./pages/NotFound"
import Unauthorized from "./pages/Unauthorized"
import Footer from "./components/Catalogo/Footer"
import Spinner from "./components/Spinner"
import AccountRegister from "./pages/AccountRegister"
import { Contenedor } from "./ui/Contenedor"
import { CustomerSeller } from "./pages/CustomersSeller"
import HomeCatalogo from "./pages/HomeCatalogo"
import Catalogo from "./pages/Catalogo"
import CatalogoDetails from "./pages/CatalogoDetails"
import Header from "./components/Header"
import RubroCatalogo from "./pages/RubroCatalogo"
import Logistica from "./pages/Logistica"
import PlanillaReparto from "./components/Logistica/PlanillaReparto/PlanillaReparto"
import Transportes from "./components/Logistica/Transportes/Transportes"
import LogisticaLayout from "./components/Logistica/Header/LogisticaLayout"
import Mantenimiento from "./pages/Mantenimiento"
import { isMaintenanceMode } from "./helpers/maintenanceMode"
import VersionUpdateDialog from "./components/VersionUpdateDialog"

const App = () => {
  const theme = useTheme()

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={usLocale}>
          <CssBaseline />
          <Spinner />
          <VersionUpdateDialog />
          <Router basename="/">
            <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
              <Box flex={1}>
                <Header />
                <Routes>
                  {isMaintenanceMode ? (
                    <Route path="*" element={<Mantenimiento />} />
                  ) : (
                  <>
                  <Route element={<PrivateRoute validRoles={["Cliente", "Administrador"]} />}>
                    <Route path={"/products"} element={<Contenedor children={<Products />} isCatalogoBreadCrumb={true} isBreadCrumb={true} />} />
                    <Route path={"/cart"} element={<Contenedor children={<Cart />} maxWidth={"xl"} />} />
                    <Route path={"/checkout"} element={<Contenedor children={<Checkout />} maxWidth={"xl"} />} />
                    <Route path={"/product-details/:productId"} element={<Contenedor children={<CatalogoDetails isClient={true} />} maxWidth={"xl"} isBreadCrumb={true} isProductDetails={true} />} />
                  </Route>
                  <Route element={<PrivateRoute validRoles={["Administrador", "Cliente", "Vendedor", "Admin Ventas"]} />}>
                    <Route exact path={"/menu"} element={<Contenedor children={<Menu />} maxWidth="xl" />} />
                  </Route>
                  <Route element={<PrivateRoute validRoles={["Administrador", "Logistica"]} />}>
                    <Route path={"/logistica"} element={<Contenedor children={<Logistica />} maxWidth="xl" />} />
                    <Route path={"/logistica/planilla-reparto"} element={<Contenedor children={<LogisticaLayout children={<PlanillaReparto />} />} maxWidth={false} />} />
                    <Route path={"/logistica/transportes"} element={<Contenedor children={<LogisticaLayout children={<Transportes />} />} maxWidth={false} />} />
                  </Route>
                  <Route element={<PrivateRoute validRoles={["Vendedor", "Admin Ventas",]} />}>
                    <Route path={"/lista-clientes"} element={<Contenedor children={<CustomerSeller />} />} />
                  </Route>
                  <Route element={<PublicRoute restricted={true} />}>
                    <Route path="/login" element={<Contenedor children={<Login />} />} />
                    <Route path="/resetpassword" element={<Contenedor children={<PasswordForgot />} />} />
                    <Route path="/register" element={<Contenedor children={<AccountRegister />} />} />
                  </Route>
                  <Route element={<PublicRoute />}>
                    <Route path={"/"} element={<HomeCatalogo />} />
                    <Route path={"/catalogo"} element={<Contenedor children={<Catalogo />} isCatalogoBreadCrumb={true} isBreadCrumb={true} />} />
                    <Route path={"/categoria/:id"} element={<RubroCatalogo />} />
                    <Route path={"/catalogo-details/:productId"} element={<Contenedor children={<CatalogoDetails />} maxWidth={"xl"} />} />
                    <Route path="/unauthorized" element={<Contenedor isVendedor={true} children={<Unauthorized />} />} />
                    <Route path="*" element={<Contenedor children={<NotFound />} />} />
                  </Route>
                  </>
                  )}
                </Routes>
              </Box>
              {/* <div className="filler" /> */}
              <Footer />
            </Box>
          </Router>
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default App